/**
 * Copyright (C) Siemens AG 1996-2025 ALL RIGHTS RESERVED.
 */

export type GlobalAlert = {
  id: string;
  title: MultiLanguageValue[];
  description: MultiLanguageValue[];
  severity: AlertSeverity;
  type: AlertType;
};

export type MultiLanguageValue = {
  language: string;
  value: string;
};

export enum AlertSeverity {
  INFO = 'info',
  WARNING = 'warning',
}

export enum AlertType {
  SINGLE = 'single',
  RECURRING = 'recurring',
}
